SelectComboTextDialog = Ext.extend(Ext.Window, {

    id: 'selectComboDialog',
    title: '<%=L.__("SELECT_COMBO_TEXT")%>',
    closable: false,
    width: 420,
    height: 160,
    modal: true,
    initComponent: function () {
        var dlg = this;
        var doSubmit = function () {

            var selfCombo = Ext.getCmp('cmbSelectNewValue');
            var didSelect = false;

            var value = selfCombo.getValue();

            selfCombo.getStore().each(function (item) {
                if (item.get('cText') == value)
                    didSelect = true;
            });

            if (didSelect) {
                //Set the new value.
                dlg.combo.setRawValue(value);
                //Fire the select method, so as to set the data dirty (provided the form is setup proper).
                dlg.combo.fireEvent('select', null);
                //Close the window.
                dlg.close();
            }
        };

        this.items = [
            {
                xtype: 'form',
                padding: 5,
                height: 75,
                labelAlign: 'right',
                id: 'frmSelectComboText',
                keys: [
                    {
                        key: [Ext.EventObject.ENTER],
                        handler: doSubmit
                    }//,
                    //					{
                    //					    key: [Ext.EventObject.ESC],
                    //					    handler: function () {
                    //					        dlg.close();
                    //					    }
                    //					}
                ],
                items:
                    [
                        {
                            id: 'lblSelectCmbDesc',
                            xtype: 'box',
                            style: 'text-align: center;padding: 10px; color: white ',
                            html: ___('SELECT_NEW_VALUE_FOR_THE_FIELD') + ' ',
                        },
                        {
                            xtype: 'combo',
                            id: 'cmbSelectNewValue',
                            fieldLabel: ___('VALUE'),
                            anchor: '100%',
                            autoSelect: true,
                            store: new Ext.data.JsonStore({
                                url: '/UCI/GetComboData',
                                root: 'cValues',
                                autoLoad: true,
                                baseParams: { table: this.table, column: this.column },
                                fields: [{ name: 'cText', mapping: 'cText' }]
                            }),
                            displayField: 'cText',
                            valueField: 'cText',
                            minChars: 0,
                            forceSelection: true,
                            allowBlank: true
                        }
                    ]
            }
        ];

        this.bbar = {
            xtype: 'toolbar',
            id: 'buttons',
            items: [
                {
                    xtype: 'tbfill'
                },
                {
                    xtype: 'button',
                    text: '  ' + ___('OK_TEXT') + '  ',
                    handler: doSubmit

                }
            ]
        };

        SelectComboTextDialog.superclass.initComponent.call(this);
    },

    listeners: {
        show: function () {
            //this.findById('selectComboDialog').focus(true, 250);
        }
    },
    load: function (table, column, combo) {
        this.table = table;
        this.column = column;

        //this.callback = callback;
        this.combo = combo;

        this.initComponent();

        //Setup some stuff
        var cmbDesc = Ext.getCmp('lblSelectCmbDesc');
        cmbDesc.html += "'" + column + "'. " + (___('THE_OLD_VALUE_WAS')).replace("{0}", combo.getRawValue());
        var selfCombo = Ext.getCmp('cmbSelectNewValue');
        selfCombo.setValue(___('SELECT_A_NEW_VALUE'));
        //Show the screen
        this.show();
    }

});

//This function works just like in Emx -- It checks the value assigned
//to the drop down box with the items in the list. If there is a mismatch, it will launch the
//dialog prompting the user to select a new value.
function SetComboText(ComboBoxID, ComboStore, Table, Column) {

    //SUPER TODO: TODO: TODO:  take out this hack.
    //We are doing this because the whole functionality for SetComboText is not fully defined and it is
    //becoming really irritating.
    //As-per ED's request. It is all his fault. =P
    return;

    try {
        if (DISABLE_SET_COMBO_TEXT !== undefined)
            if (DISABLE_SET_COMBO_TEXT === true)
                return;
    }
    catch (e) { }

    var exists = false;
    var ComboBox = Ext.getCmp(ComboBoxID);

    var SelectedText = ComboBox.getRawValue();

    //Loop through each item in the ComboBox
    ComboStore.each(function (item) {
        var value = item.get('cText');
        if (value == SelectedText) {
            exists = true;
        }
    });

    //If there is no equality, prompt the user with the new SelectComboTextDialog.
    if (!exists) {
        var newDialog = new parent.SelectComboTextDialog();
        //Show the dialog and pass the necessary values.
        newDialog.load(Table, Column, ComboBox);
    }
}